import { use } from "passport";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.less";

export const GatewayIntegrationProcess = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="gateway-process">
      <div className="process-title">{t("gateway.process.title")}</div>
      <div className="process-img">
        <img
          src={i18n.language === 'zh-CN' ? "http://files.authing.co/authing-website/gateway-integration-process.png" : 'https://authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/english.png'}
          alt="authing"
        />
      </div>
    </div>
  );
};
